import { InternalNetworkAssessmentsContract } from '@terra/shared-contracts-internal-network';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const internalNetworkAssessmentsClient = createTerraOrpcClient({
  contract: InternalNetworkAssessmentsContract,
  serviceName: 'orchestrator',
});
